var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { ViewType } from '@/domains/base/enums/view-type';
import { DataType } from '@/domains/base/enums/data-type';
import { DetailViewTypeService } from '@/services/detail-view-name-service';
import { RouterService } from '@cores/services/vue-router-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import qs from 'qs';
export const ShareLinkQuery = Symbol('ShareLinkQuery');
let ShareLinkQueryImp = class ShareLinkQueryImp {
    constructor(_routerService, _detailViewTypeService) {
        this._routerService = _routerService;
        this._detailViewTypeService = _detailViewTypeService;
    }
    getViewNameFromShareUrl() {
        const query = qs.parse(window.location.search.substring(1));
        const dataType = query.dataType || DataType.PATENT;
        const viewType = query.viewType || ViewType.TABLE;
        return {
            dataType,
            viewType,
        };
    }
    getViewNameForShare() {
        const routeParams = this._routerService.currentRoute.params;
        const dataType = routeParams.dataType || DataType.PATENT;
        const viewType = routeParams.viewType || this._detailViewTypeService.getDetailViewType() || ViewType.TABLE;
        return {
            dataType,
            viewType,
        };
    }
    getShareLinkQueryNames() {
        return ['dataType', 'viewType'];
    }
};
ShareLinkQueryImp = __decorate([
    injectable(),
    __param(0, inject(RouterService)),
    __param(1, inject(DetailViewTypeService)),
    __metadata("design:paramtypes", [typeof (_a = typeof RouterService !== "undefined" && RouterService) === "function" ? _a : Object, typeof (_b = typeof DetailViewTypeService !== "undefined" && DetailViewTypeService) === "function" ? _b : Object])
], ShareLinkQueryImp);
export { ShareLinkQueryImp };
